import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";

export const PrimaryButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: "none",
  backgroundColor: "#014DDF",
  color: "#FFF",
  borderRadius: 12,
  minHeight: 48,
  fontSize: 15,
  fontWeight: 600,
  boxShadow: "0 10px 24px rgba(1, 77, 223, 0.22)",
  "&:hover": {
    backgroundColor: "#0A229C",
    boxShadow: "0 12px 28px rgba(1, 77, 223, 0.3)",
  },
}));
